import React from "react";
import Moment from "react-moment";
import * as colors from "../settings/colors";

const getWarningColor = daysUntilDue => {
  if (daysUntilDue < 1) {
    return colors.RED;
  } else if (daysUntilDue < 2) {
    return colors.ORANGE;
  } else if (daysUntilDue < 3) {
    return colors.GREEN;
  }

  return null;
};

const PostedTurnaround = ({
  date,
  children,
  format = "MMM D, YYYY",
  style = {}
}) => {
  const postedTurnaround = new Date(date || children);
  const daysUntilDue = Math.ceil(
    (new Date(postedTurnaround) - new Date()) / (1000 * 60 * 60 * 24)
  );
  const warningColor = getWarningColor(daysUntilDue);

  return (
    <Moment
      style={{ ...style, color: warningColor }}
      date={postedTurnaround}
      format={format}
      utc
    />
  );
};

export default PostedTurnaround;



// WEBPACK FOOTER //
// ./src/components/PostedTurnaround.js